import React from "react";
import { Button } from "antd";
import "./company-inactive.css";

const defaultLogo = "/images/logo.png";

const CompanyInactive = ({ company }) => {
  const logoSrc = company?.pictureFileName
    ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${company.pictureFileName}`
    : defaultLogo;

  return (
    <div className="company-inactive">
      <div className="company-inactive-inner">
        <h1 className="company-inactive-title">Компания неактивна</h1>
        <div className="company-inactive-logo-wrap">
          <img
            className="company-inactive-logo"
            src={logoSrc}
            alt=""
            onError={(e) => {
              e.currentTarget.src = defaultLogo;
            }}
          />
        </div>
        <Button type="primary" size="large" onClick={() => window.location.reload()}>
          Обновить
        </Button>
      </div>
    </div>
  );
};

export default CompanyInactive;
